import React from "react";
import { Stack, Chip, Tooltip } from "@mui/material";
import { blue, red, grey } from "@mui/material/colors";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import PersonIcon from "@mui/icons-material/Person";
import GavelIcon from "@mui/icons-material/Gavel";
import SecurityIcon from "@mui/icons-material/Security";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import Role from "../../../../utils/roles";
import { roleMatchesFrameworkFilter } from "../../../../utils/staffRoleFrameworkFilter";
const RoleChips = ({
  roles,
  onRemoveRole,
  peopleOpsNameData,
  complianceNameData,
  infosecNameData,
  consentMgrNameData,
  dpoNameData,
  subscribedFrameworkKeys,
  roleFrameworkKeysByDescription,
}) => {
  if (!roles || roles?.length === 0) return null;

  const filteredRoles = roles?.filter(
    (role) =>
      role?.role_description &&
      role?.role_name?.toLowerCase() !== "admin" &&
      roleMatchesFrameworkFilter(
        roleFrameworkKeysByDescription?.[role?.role_description],
        subscribedFrameworkKeys
      )
  );

  if (filteredRoles?.length === 0) return null;

  const getRoleNameByDescription = (description) => {
    if (description === Role?.PEOPLE_OPERATIONS) {
      return peopleOpsNameData?.getRoleNameByDescription?.role_name || "";
    } else if (description === Role?.COMPLIANCE_PROGRAM_MANAGER) {
      return complianceNameData?.getRoleNameByDescription?.role_name || "";
    } else if (description === Role?.INFORMATION_SECURITY_OFFICER) {
      return infosecNameData?.getRoleNameByDescription?.role_name || "";
    } else if (description === Role?.CONSENT_MANAGER) {
      return consentMgrNameData?.getRoleNameByDescription?.role_name || "";
    } else if (description === Role?.DATA_PRIVACY_OFFICER) {
      return dpoNameData?.getRoleNameByDescription?.role_name || "";
    }
    return "";
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: 1,
        "& > *": {
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          },
        },
      }}
    >
      {filteredRoles.map((role) => {
        const roleName = getRoleNameByDescription(role?.role_description);
        const icon =
          role?.role_description === Role?.PEOPLE_OPERATIONS ? (
            <PersonIcon />
          ) : role?.role_description === Role?.COMPLIANCE_PROGRAM_MANAGER ? (
            <GavelIcon />
          ) : role?.role_description === Role?.INFORMATION_SECURITY_OFFICER ? (
            <SecurityIcon />
          ) : role?.role_description === Role?.CONSENT_MANAGER ? (
            <PrivacyTipIcon />
          ) : role?.role_description === Role?.DATA_PRIVACY_OFFICER ? (
            <VerifiedUserIcon />
          ) : null;

        if (!roleName || !icon) return null;

        return (
          <Tooltip key={role?.role_id} title={roleName} arrow placement="top">
            <Chip
              label={roleName}
              size="small"
              onDelete={() =>
                onRemoveRole({
                  name: roleName,
                  description: role?.role_description,
                })
              }
              deleteIcon={
                <RemoveCircleIcon
                  sx={{
                    fontSize: "1rem !important",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      color: red[600],
                      transform: "scale(1.1)",
                    },
                  }}
                />
              }
              sx={{
                backgroundColor: `${blue[700]}08`,
                color: blue[700],
                border: `1px solid ${blue[700]}40`,
                fontWeight: 500,
                fontSize: "0.75rem",
                height: 24,
                borderRadius: 1,
                px: 0.6,
                boxShadow: "none",

                "& .MuiChip-label": {
                  px: 1,
                  py: 0,
                  lineHeight: 1,
                },
                "& .MuiChip-deleteIcon": {
                  color: grey[400],
                  fontSize: "1rem",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    color: red[600],
                  },
                },
                "&:hover": {
                  backgroundColor: `${blue[700]}15`,
                  borderColor: `${blue[700]}60`,
                },
                "&:active": {
                  transform: "scale(0.98)",
                },
              }}
              icon={React.cloneElement(icon, {
                sx: {
                  fontSize: "0.875rem !important",
                  color: blue[700],
                  mr: -0.5,
                },
              })}
            />
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default RoleChips;
